<script setup lang="ts">
const model = defineModel<boolean>();

defineProps<{
    id: string;
    label: string;
    bold?: boolean;
}>();
</script>

<template>
    <input :id="id" v-model="model" type="checkbox" />
    <label
        :for="id"
        class="label-checkbox"
        :class="{ 'label-checkbox-bold': bold }"
    >
        {{ label }}
    </label>
</template>

<style scoped>
input[type="checkbox"] {
    display: none;
}

.label-checkbox {
    position: relative;
    padding: 0.25rem 0.25rem 0.25rem 2.25rem;
}

.label-checkbox-bold {
    font-weight: 700;
}

input[type="checkbox"]:checked + label::before {
    background-image: url("../../../assets/icons/tick.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px 18px;
    border-color: #00913d;
}

.label-checkbox::before {
    content: " ";
    border-radius: 3px;
    border: 1px solid #666;
    width: 30px;
    height: 30px;
    display: block;
    position: absolute;
    left: 0;
    top: 2px;
}
</style>
